import React from "react";
import { compose, withAppContext, withActions } from "containers/HOC";
import arrayMutators from "final-form-arrays";
import { Form, Field } from "react-final-form";
import * as utils from "common/utils";
import * as FormUtils from "common/FormUtils";
import Loader from "components/Loader";
import Modal from "components/new/Modal";
import ModalBody from "components/new/ModalBody";
import ModalFooter from "components/new/ModalFooter";
import Grid from "components/Grid";
import GridCell from "components/GridCell";
import TextareaPack from "components/TextareaPack";
import { addTicketComment, closeSupportModal } from "./_actions";

class EditSupportTicketModal extends React.Component {
    _validate = (values) => {
        const errors = {};

        errors.newComment = FormUtils.validators.maxLength(1000)(values.newComment);

        return errors;
    };

    _save = (values) => {
        this.props.addTicketComment(values.id, values.newComment.trim(), this.props.closeSupportModal);
    };

    render() {
        const { online, viewModel, closeSupportModal } = this.props;

        if (!viewModel) return <Loader message="Loading..." />;

        return (
            <Form
                initialValues={viewModel}
                mutators={{
                    setProperty: (args, state, utils) => {
                        utils.changeValue(state, args[0], () => args[1]);
                    },
                    ...arrayMutators,
                }}
                validate={this._validate}
                onSubmit={this._save}
            >
                {({ form, values, handleSubmit, submitSucceeded, dirty }) => {
                    return (
                        <Modal title={`Support ticket - ${viewModel.subject} (${viewModel.id})`} onClose={closeSupportModal}>
                            {({ closeModal }) => (
                                <form onSubmit={handleSubmit}>
                                    <ModalBody>
                                        <div className="Table u-mt-md">
                                            <div style={{ overflowY: "scroll" }}>
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th data-width="17.5">Created</th>
                                                            <th data-width="17.5">By</th>
                                                            <th>Comment</th>
                                                        </tr>
                                                    </thead>
                                                </table>
                                            </div>
                                            <div style={{ maxHeight: "400px", overflowY: "scroll" }}>
                                                <table>
                                                    <tbody>
                                                        {viewModel.comments.map((comment) => {
                                                            const createdBy = comment.via.source.from.name;
                                                            const commentLines = comment.body.split("\n");
                                                            return (
                                                                <tr key={comment.id} className="hover" valign="top">
                                                                    <td data-width="17.5">{utils.dateLong(comment.created_at)}</td>
                                                                    <td data-width="17.5">{createdBy || "Overseer Support"}</td>
                                                                    <td>
                                                                        {commentLines.map((line, i) => (
                                                                            <p key={i}>{line}</p>
                                                                        ))}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        {viewModel.status !== "Closed" && (
                                            <Grid>
                                                <GridCell>
                                                    <Field name="newComment" label="Comment" type="text" autoFocus={true} placeholder="Add comment..." component={TextareaPack} />
                                                </GridCell>
                                            </Grid>
                                        )}
                                    </ModalBody>
                                    <ModalFooter>
                                        <div className="ButtonBar">
                                            <div className="ButtonBar-left">
                                                <button id="cancel-button" type="button" className="Button Button--secondary" onClick={closeSupportModal}>
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="ButtonBar-right">
                                                <button id="save-button" type="submit" className="Button" disabled={!online || !dirty || submitSucceeded}>
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </ModalFooter>
                                </form>
                            )}
                        </Modal>
                    );
                }}
            </Form>
        );
    }
}
export default compose(withAppContext, withActions({ addTicketComment, closeSupportModal }))(EditSupportTicketModal);
